import { computed, ref } from 'vue';

export const Breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600,
};

export const getCurrentBreakpoints = (): string[] => {
  const bps: string[] = [];

  Object.entries(Breakpoints).forEach(([key, size]) => {
    if (window.innerWidth >= size) {
      bps.push(key);
    }
  });

  return bps;
};

interface ScrollToOptions {
  offset?: number
  windowPercentage?: number
}
export const scrollTo = (target: HTMLElement | number | string, options: ScrollToOptions = {}): void => {
  let scrollToY = target as number;

  if (typeof target === 'string') {
    scrollToY = (document.getElementById(target)?.getBoundingClientRect().top || 0) + window.scrollY;
  } else if (typeof target !== 'number') {
    scrollToY = target.getBoundingClientRect().top + window.scrollY;
  }

  const windowOffsetPercentage = typeof options.windowPercentage === 'number' ? options.windowPercentage : 0.33333;

  scrollToY -= window.innerHeight * windowOffsetPercentage;
  scrollToY += options.offset || 0;

  const bodyStyles = getComputedStyle(document.body);
  const headerHeightTransformed = parseInt(bodyStyles.getPropertyValue('--app-header-height-transformed') || '0', 10);
  scrollToY -= headerHeightTransformed;

  window.scrollTo({ top: scrollToY, behavior: 'smooth' });
};

export const currentBreakpoints = ref<string[]>([]);

export const isMobile = computed<boolean>(() => !getCurrentBreakpoints().includes('lg'));
export const initCustomBreakpointHandler = () => {
  const checkIfResized = () => {
    const bps = getCurrentBreakpoints();

    if (bps.length !== currentBreakpoints.value.length) {
      const breakpointChangedEvent = new CustomEvent('viewport.breakpoint.changed', {
        bubbles: true,
        detail: {
          breakpoints: bps,
          isMobile: !bps.includes('lg'),
        },
      });

      window.dispatchEvent(breakpointChangedEvent);

      currentBreakpoints.value = bps;
    }
  };

  window.addEventListener('resize', checkIfResized);
  window.addEventListener('load', checkIfResized);
  checkIfResized();
};

export const onBreakpointChanged = (callback: (...params: any) => void, immediate = false) => {
  window.addEventListener('viewport.breakpoint.changed', callback);

  if (immediate) {
    const bps = getCurrentBreakpoints();

    const breakpointChangedEvent = new CustomEvent('viewport.breakpoint.changed', {
      bubbles: true,
      detail: {
        windowWidth: window.innerWidth,
        breakpoints: bps,
        isMobile: !bps.includes('lg'),
      },
    });

    callback(breakpointChangedEvent);
  }
};

export const removeOnBreakpointChanged = (callback: (...params: any) => void) => {
  window.removeEventListener('viewport.breakpoint.changed', callback);
};
